import { FC } from 'react';
import * as React from 'react';

import {
  ClassNotes as ClassNotesModule,
  type MyNotesProps,
} from '@/shared/components';

import { ENROLLMENTS_COURSES_ROUTE, ENROLLMENTS_ROUTE } from '../config';

const ClassNotes: FC<React.PropsWithChildren<MyNotesProps>> = props => (
  <ClassNotesModule
    {...props}
    enrollmentsCoursesRoutePath={ENROLLMENTS_COURSES_ROUTE.path}
    enrollmentsRoutePath={ENROLLMENTS_ROUTE.path}
  />
);

export default ClassNotes;
